var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWebAdaptive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.069 18.932v-.118a10.294 10.294 0 01-7.856 5.087l-.154.016c-6.442.634-8.345-4.077-6.556-6.382 1.457-1.876 3.585-1.256 4.31-.438a.06.06 0 00.073.012.061.061 0 00.032-.067c-.195-.84-1.087-3.363-4.78-3.363-4.974 0-8.166 4.871-7.755 10.22a11.003 11.003 0 01-1.273-5.09c0-2.595.821-4.773 2.464-6.534 1.642-1.76 3.74-2.642 6.294-2.643 2.514 0 4.592.881 6.236 2.643l.018.02a7.654 7.654 0 011.967 4.18c.227 1.637.17 3.874-1.406 5.173a.048.048 0 00.009.081c.01.005.02.006.032.003.545-.146 1.08-.33 1.601-.55 1.962-.815 5.052-2.536 6.274-6.045a.434.434 0 00.012-.252 14.539 14.539 0 00-3.91-6.793c-2.923-2.92-6.53-4.382-10.821-4.385-4.292-.003-7.901 1.462-10.827 4.394C8.13 11.026 6.67 14.6 6.673 18.818V19.265C6.928 32.069 21.87 38.553 21.87 38.553s14.935-6.484 15.198-19.286v-.161-.173z",
    fill: "url(#logo_web_adaptive_svg__paint0_linear_2219_16139)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_web_adaptive_svg__paint0_linear_2219_16139",
    x1: 21.894,
    y1: 38.455,
    x2: 40.063,
    y2: 13.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03D9B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1CBBD9"
  })))));
}
export default SvgLogoWebAdaptive;